import { Injectable } from '@angular/core';
import { EnvironmentDataProvider } from '@lib.core/environment/interface';
import { EnvironmentResource } from '@lib.resources/environment/resource';
import { environment } from '@public/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentAccessService implements EnvironmentDataProvider, EnvironmentResource {
  getBaseUrl(): string {
    return environment.ecdevManageApiBaseUrl;
  }

  getVectorTileBaseUrl(): string {
    return environment.vectorTileBaseUrl;
  }
}
